module.exports = __webpack_public_path__ + "stylesheets/video-folder-breadcrumb_ca1f14526dbfe11c01a588150d37a187.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/wave/folder/video-folder-breadcrumb.less
// module id = OjHm
// module chunks = 153